import { generateSectionId } from '../helpers/layout-helpers';
import React, { useState, useEffect, useContext } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { inView, inViewBottom } from '../helpers/layout-helpers';

// External components
import { HiMenu } from 'react-icons/hi';
import { LangContext } from '../contexts/Lang';

export default function SideMenu({ pages }) {
  const { globalPageData } = useContext(LangContext);
  const [mobileNav, toggleMobileNav] = useState(false);
  const [currentSection, setCurrentSection] = useState('site-intro');
  const onScroll = (e) => {
    const sections = document.querySelectorAll('.can-scroll-to');
    const siteIntro = document.querySelector('header');
    if (!sections) return;

    if (siteIntro && inViewBottom(siteIntro)) {
      return setCurrentSection('site-intro');
    }

    sections.forEach((section) => {
      //switch to children if theres nested sections
      // console.log(section, inView(section));
      if (inView(section)) {
        const sectionChildren = section.querySelectorAll('.can-scroll-to');
        // setCurrentSection(section.id);
        if (sectionChildren?.length > 0) {
          sectionChildren.forEach((childSection) => {
            if (inView(childSection)) {
              return setCurrentSection(childSection.id);
            }
          });
        } else {
          return setCurrentSection(section.id);
        }
      }
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    if (mobileNav) {
      document.body.classList.add('no-scroll');
    } else if (!mobileNav) {
      document.body.classList.remove('no-scroll');
    }
  }, [mobileNav]);

  const MenuItems = () =>
    pages?.reduce((results, page) => {
      const targetId = generateSectionId(page);
      const href = '#' + targetId;
      let className = 'item';
      if (targetId === currentSection) {
        className += ' active';
      }
      if (page?.sideMenuTitle) {
        results.push(
          <li className={className} key={page.key}>
            <a href={href} key={page.key}>
              {page.sideMenuTitle}
            </a>
          </li>
        );
      }
      if (page.children && page.children.length > 0) {
        page.children.forEach((childItem) => {
          if (childItem?.sideMenuTitle) {
            const childTargetId = generateSectionId(childItem);

            let childClass = 'sub-item';
            if (childTargetId === currentSection) {
              childClass += ' active';
            }
            const childHref = '#' + childTargetId;
            results.push(
              <li className={childClass} key={childItem.key}>
                <AnchorLink href={childHref} key={childItem.key}>
                  {childItem.sideMenuTitle}
                </AnchorLink>
              </li>
            );
          }
        });
      }
      return results;
    }, []);
  return (
    <>
      <HiMenu
        size='4rem'
        className='side-menu-toggler'
        onClick={() => toggleMobileNav(!mobileNav)}
      />
      <aside
        className={`side-menu ${mobileNav ? 'side-menu-visible-mobile' : ''}`}
        onClick={() => toggleMobileNav(!mobileNav)}>
        <ul>
          <li className='title' key='side-top-h3'>
            <div
              dangerouslySetInnerHTML={{
                __html: `${
                  globalPageData.velgKategori?.length > 0
                    ? globalPageData.velgKategori
                    : 'Velg kategori'
                }`,
              }}></div>
          </li>
          <div className='side-menu-items'>
            <MenuItems showItems={true} />
          </div>
          <div className='side-menu-items-mobile'>
            <MenuItems showItems={mobileNav} />
          </div>
        </ul>
      </aside>
    </>
  );
}
